(function () {
    'use strict';

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initResetPasswordForm);
    } else {
        initResetPasswordForm();
    }

    function initResetPasswordForm() {
        const resetPasswordForm = document.querySelector('.thb-login-form');
        if (!resetPasswordForm) return;

        const form = resetPasswordForm.querySelector('form');
        if (!form) return;

        // DOM Element Queries
        const passwordInput = form.querySelector('#password');
        const passwordConfirmInput = form.querySelector('#password_confirmation');
        const requirementItems = form.querySelectorAll('.password-requirements li');
        const submitBtn = form.querySelector('button[type="submit"]');

        // Validation state
        const validationState = {
            password: false,
            passwordMatch: false
        };

        // Track if password field has been interacted with
        let passwordInteracted = false;
        let confirmInteracted = false;

        // Password Validation
        function validatePassword(showErrors) {
            if (!passwordInput) return false;

            const password = passwordInput.value;
            const rules = [
                { regex: /.{8,}/, element: requirementItems[0], key: 'length' },
                { regex: /[A-Z]/, element: requirementItems[1], key: 'uppercase' },
                { regex: /[a-z]/, element: requirementItems[2], key: 'lowercase' },
                { regex: /[0-9]/, element: requirementItems[3], key: 'number' }
            ];

            let validCount = 0;

            rules.forEach(rule => {
                if (!rule.element) return;

                const iconGray = rule.element.querySelector('.icon-gray');
                const iconRed = rule.element.querySelector('.icon-red');
                const iconGreen = rule.element.querySelector('.icon-green');

                if (!passwordInteracted) {
                    // Initial state: show gray, hide red and green
                    if (iconGray) {
                        iconGray.classList.remove('hide');
                        iconGray.classList.add('show');
                    }
                    if (iconRed) {
                        iconRed.classList.remove('show');
                        iconRed.classList.add('hide');
                    }
                    if (iconGreen) {
                        iconGreen.classList.remove('show');
                        iconGreen.classList.add('hide');
                    }
                } else {
                    // User has interacted: show red or green based on validation
                    const isValid = rule.regex.test(password);

                    if (isValid) {
                        // Valid: show green, hide gray and red, add valid class to li
                        rule.element.classList.remove('invalid');
                        rule.element.classList.add('valid');
                        if (iconGray) {
                            iconGray.classList.remove('show');
                            iconGray.classList.add('hide');
                        }
                        if (iconRed) {
                            iconRed.classList.remove('show');
                            iconRed.classList.add('hide');
                        }
                        if (iconGreen) {
                            iconGreen.classList.remove('hide');
                            iconGreen.classList.add('show');
                        }
                        validCount++;
                    } else {
                        // Invalid: show red, hide gray and green, add invalid class to li
                        rule.element.classList.remove('valid');
                        rule.element.classList.add('invalid');
                        if (iconGray) {
                            iconGray.classList.remove('show');
                            iconGray.classList.add('hide');
                        }
                        if (iconRed) {
                            iconRed.classList.remove('hide');
                            iconRed.classList.add('show');
                        }
                        if (iconGreen) {
                            iconGreen.classList.remove('show');
                            iconGreen.classList.add('hide');
                        }
                    }
                }
            });

            const isValid = validCount === 4;
            validationState.password = isValid;
            return isValid;
        }

        // Password Match Validation
        function validatePasswordMatch() {
            if (!passwordInput || !passwordConfirmInput) return false;

            const password = passwordInput.value;
            const confirmPassword = passwordConfirmInput.value;

            // If confirmation field is empty or hasn't been interacted with, don't validate
            if (!confirmInteracted || !confirmPassword) {
                validationState.passwordMatch = false;
                return false;
            }

            const isMatch = password === confirmPassword && password !== '';
            validationState.passwordMatch = isMatch;

            // Add visual feedback to confirmation field
            if (confirmInteracted) {
                if (isMatch) {
                    passwordConfirmInput.classList.remove('invalid');
                    passwordConfirmInput.classList.add('valid');
                } else {
                    passwordConfirmInput.classList.remove('valid');
                    passwordConfirmInput.classList.add('invalid');
                }
            }

            return isMatch;
        }

        function checkFormValidity() {
            validatePassword(true);
            validatePasswordMatch();

            const isFormValid = validationState.password && validationState.passwordMatch;

            if (submitBtn) {
                submitBtn.disabled = !isFormValid;
            }

            return isFormValid;
        }

        if (passwordInput) {
            passwordInput.addEventListener('input', function () {
                passwordInteracted = true;
                validatePassword(true);
                validatePasswordMatch();
                checkFormValidity();
            });

            passwordInput.addEventListener('focus', function () {
                passwordInteracted = true;
                validatePassword(true);
            });

            passwordInput.addEventListener('blur', function () {
                passwordInteracted = true;
                validatePassword(true);
                checkFormValidity();
            });
        }

        if (passwordConfirmInput) {
            passwordConfirmInput.addEventListener('input', function () {
                confirmInteracted = true;
                validatePasswordMatch();
                checkFormValidity();
            });

            passwordConfirmInput.addEventListener('blur', function () {
                confirmInteracted = true;
                validatePasswordMatch();
                checkFormValidity();
            });

            passwordConfirmInput.addEventListener('focus', function () {
                confirmInteracted = true;
            });
        }

        const toggleButtons = form.querySelectorAll('.password-toggle');

        toggleButtons.forEach(button => {
            if (button.dataset.initialized === 'true') return;
            button.dataset.initialized = 'true';

            const field = button.closest('.password-field');
            if (!field) return;

            const input = field.querySelector('input');
            if (!input) return;

            const svgs = button.querySelectorAll('svg');
            const eyeOpen = svgs[0];
            const eyeClose = svgs[1];

            if (eyeOpen && eyeClose) {
                eyeOpen.style.display = 'block';
                eyeClose.style.display = 'none';
            }

            button.addEventListener('click', function (e) {
                e.preventDefault();
                e.stopPropagation();

                const isPassword = input.type === 'password';
                input.type = isPassword ? 'text' : 'password';

                if (eyeOpen && eyeClose) {
                    eyeOpen.style.display = isPassword ? 'none' : 'block';
                    eyeClose.style.display = isPassword ? 'block' : 'none';
                }
            });
        });

        // Form Submission
        if (form) {
            form.addEventListener('submit', function (e) {
                passwordInteracted = true;
                confirmInteracted = true;

                if (!checkFormValidity()) {
                    e.preventDefault();
                    return false;
                }
            });
        }

        validatePassword(false);
    }
})();